<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="400"
      offset-x
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          color="white"
          v-bind="attrs"
          @click="menu = true"
          v-on="on"
        >
          <v-badge
            :content="getNotifications.length"
            color="green"
            :overlap="true"
            dark
          >
            <v-icon large>
              mdi-account-multiple-plus-outline
            </v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-card height="100%">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Invitaciones</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider />

        <v-list two-line>
          <v-list-item-group
            v-if="getNotifications.length > 0"
          >
            <v-list-item
              v-for="(notification, i) in notifications"
              v-show="!notification.confirmated"
              :key="i"
            >
              <v-list-item-action>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon>
                      <v-icon
                        large
                        color="red"
                        v-bind="attrs"
                        @click="deleteNotification(i)"
                        v-on="on"
                      >
                        mdi-do-not-disturb-off
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Rechazar</span>
                </v-tooltip>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">
                  Invitación Estudiante
                </v-list-item-title>
                <v-list-item-subtitle
                  class="text--primary"
                >
                  Padre: {{ notification.parentEmail }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  Estudiante: {{ notification.studentEmail }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn
                  small
                  outlined
                  color="primary"
                  class="ma-auto"
                  @click="acceptNotification(i)"
                >
                  Aceptar Invitación
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-divider />
          </v-list-item-group>

          <v-list-item-group v-else>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  No tiene invitaciones
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-menu>
    <v-dialog
      v-model="dialogConfirmation"
      max-width="290"
    >
      <v-card>
        <v-card-text>
          <div v-if="del">
            ¿Esta seguro que desea Rechazar/Eliminar la invitación seleccionada?
          </div>
          <div v-else>
            ¿Esta seguro que desea aceptar la invitación seleccionada?
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            v-if="del"
            color="red darken-1"
            text
            @click="deletionConfirmed()"
          >
            Eliminar
          </v-btn>

          <v-btn
            v-else
            color="green darken-1"
            text
            @click="acceptConfirmed()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        fav: true,
        menu: false,
        message: false,
        hints: true,
        dialogConfirmation: false,
        del: true,
        index: '',
      }
    },
    computed: {
      ...mapState(['notifications', 'user']),
      getNotifications () {
        return (this.notifications.length) > 0 ? this.notifications.filter(n => n.confirmated === false) : []
      },
    },
    methods: {
      deleteNotification (index) {
        this.del = true
        this.dialogConfirmation = true
        this.index = index
      },
      acceptNotification (index) {
        this.del = false
        this.dialogConfirmation = true
        this.index = index
      },
      deletionConfirmed () {
        this.dialogConfirmation = false
        const notifications = this.notifications
        const dataStudent = {
          studentId: notifications[this.index].studentId,
          confirmated: false,
        }
        this.notifications.splice(this.index, 1)
        this.$store.dispatch('UPDATE_USER_NOTIFICATIONS', notifications)
        this.$store.dispatch('UPDATE_STUDENT_INVITATION', dataStudent)
      },
      acceptConfirmed () {
        this.dialogConfirmation = false
        const notifications = this.notifications
        notifications[this.index].confirmated = true
        notifications[this.index].dateConfirmated = new Date().toISOString().substr(0, 10)
        const dataStudent = {
          studentId: notifications[this.index].studentId,
          confirmated: true,
        }
        this.$store.dispatch('UPDATE_USER_NOTIFICATIONS', notifications)
        this.$store.dispatch('UPDATE_STUDENT_INVITATION', dataStudent)
      },
    },
  }
</script>
